import { assertSupabaseConfigured, supabase } from "../lib/supabase";
import type { TrainerProfile } from "../types/trainer";

export const trainerProfileService = {
  async getCurrent(tenantId: string): Promise<TrainerProfile> {
    assertSupabaseConfigured();

    const { data, error } = await supabase.rpc("ensure_trainer_profile", {
      p_tenant_id: tenantId,
    });

    if (error) throw error;
    return data as TrainerProfile;
  },

  async update(profileId: string, input: Partial<TrainerProfile>) {
    assertSupabaseConfigured();

    const { error } = await supabase
      .from("trainer_profiles")
      .update({
        display_name: input.display_name,
        role_title: input.role_title,
        bio: input.bio,
        qualifications: input.qualifications,
        specialisms: input.specialisms,
        profile_photo_url: input.profile_photo_url,
        contact_email: input.contact_email,
        contact_phone: input.contact_phone,
      })
      .eq("id", profileId);

    if (error) throw error;
  },
};
